import { useEffect, useState, ReactElement, useContext } from "react";

// material-ui
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

// third party
import PerfectScrollbar from "react-perfect-scrollbar";

// project imports
import ItemComment from "./ItemComment";
import EditItem from "./EditItem";
import AddItemComment from "./AddItemComment";
import AlertItemDelete from "./AlertItemDelete";
import { openSnackbar } from "store/slices/snackbar";
import { useDispatch, useSelector } from "store";
import { selectItem, deleteItem } from "store/slices/kanban";

// assets
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

// types
import { DefaultRootStateProps } from "types";
import { KanbanItem } from "types/kanban";
import { BoardContext } from ".";

// ==============================|| KANBAN BOARD - ITEM DETAILS ||============================== //

let userStory = [
  {
    acceptance: "",
    assign: "profile-2",
    columnId: "column-4",
    commentIds: ["comment-5"],
    description:
      "Wo gegew jubva wiej pisniidi ic jarge mide ho ufcakub culuw ambupan te fezop rikic ekbet sevzog.",
    dueDate: "Mon Feb 27 2023 15:18:32 GMT+0530 (India Standard Time)",
    id: "2647",
    priority: "low",
    title: "School Management Backend",
    itemIds: ["3542", "8903", "1381"],
  },
  {
    acceptance:
      "Gid gimija ufuebjop vuji ze ir wi jih aruvihdok keubagob aguhogug uge tabu cure.",
    assign: "profile-3",
    columnId: "column-1",
    commentIds: ["comment-3"],
    description:
      "Onekane urwa joduzzij la cipebo zafuw atawa labfi hilza inepehhow inujufise hum.",
    dueDate: "Thu Feb 23 2023 15:13:31 GMT+0530 (India Standard Time)",
    id: "7833",
    priority: "high",
    title: "Inventory Implementation & Design",
    itemIds: ["4398", "3410"],
  },
  {
    acceptance:
      "Kiz ovmen fup jazaj rozibco fecki rasizsed pake redufkav joczatufo.",
    assign: "profile-3",
    columnId: "column-4",
    commentIds: ["comment-3", "comment-4"],
    description:
      "Lum vofdip keci fid fos di fikga kiinte izugfi gihude tewsadez ha niprizbef catin adahup.",
    dueDate: "Wed Feb 15 2023 10:30:11 GMT+0530 (India Standard Time)",
    id: "6940",
    priority: "medium",
    title: "Theme migration from v4 to v5",
    itemIds: ["6739", "9589", "8679"],
  },
  {
    acceptance: "Itorinceg cokmu ku pahkaavo argut.",
    assign: "profile-1",
    columnId: "column-3",
    commentIds: ["comment-4"],
    description:
      "Nar noljaw hi fusurri haodabi ewaw uc moetucu hilzirzo ca nidzerog ziw.",
    dueDate: "Tue Feb 07 2023 15:17:40 GMT+0530 (India Standard Time)",
    id: "4656",
    priority: "low",
    title: "Lunch Beauty Application",
    itemIds: ["3950", "6924"],
  },
];

let columns = [
  {
    id: "column-1",
    title: "New",
    itemIds: ["3542", "8903", "1381"],
  },
  {
    id: "column-2",
    title: "Active",
    itemIds: ["6739", "3950", "6924"],
  },
  {
    id: "column-3",
    title: "Resolved",
    itemIds: ["4398"],
  },
  {
    id: "column-4",
    title: "Closed",
    itemIds: ["9589", "3410", "8679"],
  },
];

let items: KanbanItem[] = [
  {
    assign: "profile-1",
    attachments: [],
    commentIds: ["comment-1"],
    description: "Content of item 1",
    dueDate: "Fri Feb 03 2023 15:20:14 GMT+0530 (India Standard Time)",
    id: "3542",
    image: "profile-back-1.png",
    priority: "low",
    title: "Online fees payment & instant announcements",
  },
  {
    assign: "profile-2",
    attachments: [],
    commentIds: ["comment-2", "comment-5"],
    description: "Content of item 2",
    dueDate: "Sat Jan 28 2023 15:23:25 GMT+0530 (India Standard Time)",
    id: "4398",
    image: false,
    priority: "high",
    title: "Creation and Maintenance of Inventory Objects",
  },
  {
    assign: "profile-3",
    attachments: [],
    description: "Content of item 3",
    dueDate: "Tue Feb 07 2023 15:24:38 GMT+0530 (India Standard Time)",
    id: "6739",
    image: false,
    priority: "low",
    title: "Update React & TypeScript version",
  },
  {
    assign: "profile-2",
    attachments: [],
    commentIds: ["comment-4"],
    description: "Content of item 4",
    dueDate: "Thu Feb 09 2023 15:25:46 GMT+0530 (India Standard Time)",
    id: "3950",
    image: "profile-back-2.png",
    priority: "low",
    title: "Set allowing rules for trusted applications.",
  },
  {
    assign: "profile-2",
    attachments: [],
    commentIds: ["comment-1", "comment-2", "comment-5"],
    description: "Content of item 5",
    dueDate: "Mon Feb 06 2023 15:26:53 GMT+0530 (India Standard Time)",
    id: "6924",
    image: "profile-back-3.png",
    priority: "medium",
    title: "Managing Applications Launch Control",
  },
  {
    assign: "profile-3",
    attachments: [],
    commentIds: ["comment-3", "comment-4"],
    description: "Content of item 6",
    dueDate: "Wed Feb 15 2023 10:30:37 GMT+0530 (India Standard Time)",
    id: "9589",
    image: false,
    priority: "medium",
    title: "Run codemods",
  },
  {
    assign: "profile-1",
    attachments: [],
    description: "Content of item 7",
    dueDate: "Mon Feb 20 2023 15:29:58 GMT+0530 (India Standard Time)",
    id: "3410",
    image: "profile-back-4.png",
    priority: "low",
    title: "Purchase Requisitions, Adjustments, and Transfers.",
  },
  {
    assign: "profile-1",
    attachments: [],
    description: "Content of item 8",
    dueDate: "Sat Mar 04 2023 15:31:05 GMT+0530 (India Standard Time)",
    id: "8903",
    image: false,
    priority: "low",
    title: "Attendance checking & homework details",
  },
  {
    assign: "profile-3",
    attachments: [],
    commentIds: ["comment-3"],
    description: "Content of item 9",
    dueDate: "Thu Feb 23 2023 15:32:13 GMT+0530 (India Standard Time)",
    id: "1381",
    image: false,
    priority: "high",
    title: "Admission, Staff & Schedule management",
  },
  {
    assign: "profile-2",
    attachments: [],
    commentIds: ["comment-5"],
    description: "Content of item 10",
    dueDate: "Mon Feb 27 2023 15:33:04 GMT+0530 (India Standard Time)",
    id: "8679",
    image: false,
    priority: "low",
    title: "Handling breaking changes",
  },
];

let comments = [
  {
    id: "comment-1",
    comment: "Comment 1",
    profileId: "profile-1",
  },
  {
    id: "comment-2",
    comment: "Comment 2",
    profileId: "profile-2",
  },
  {
    id: "comment-3",
    comment: "Comment 3",
    profileId: "profile-3",
  },
  {
    id: "comment-4",
    comment: "Comment 4",
    profileId: "profile-2",
  },
  {
    id: "comment-5",
    comment: "Comment 5",
    profileId: "profile-3",
  },
];

let profiles = [
  {
    id: "profile-1",
    avatar: "avatar-3.png",
    name: "Barney Thea",
    time: "2 min ago",
  },
  {
    id: "profile-2",
    avatar: "avatar-1.png",
    name: "Maddison Wilber",
    time: "1 day ago",
  },
  {
    id: "profile-3",
    avatar: "avatar-2.png",
    name: "John Doe",
    time: "now",
  },
];

const ItemDetails = () => {
  const dispatch = useDispatch();
  const { boardItemEdit, setBoardItemEdit } = useContext(BoardContext);

  // const kanban = useSelector((state: DefaultRootStateProps) => state.kanban);
  // const {
  //   selectedItem,

  //   //  columns,
  //   //  comments,
  //   //  profiles,
  //   //  items,
  //   //  userStory,
  // } = kanban;

  const [selectedItem, setSelectedItem] = useState<string | null>("3542");
  const [open, setOpen] = useState<boolean>(false); // Simplified initial state
  const [openDrawer, setOpenDrawer] = useState<boolean>(false); // Simplified initial state

  // Automatically open drawer when `selectedItem` changes
  useEffect(() => {
    if (boardItemEdit) {
      setOpen(true);
    }
  }, [boardItemEdit]);

  // Toggle drawer open/close
  const handleDrawerOpen = () => {
    setOpen((prevState) => !prevState);
    setBoardItemEdit(false);

    if (!open) {
      dispatch(selectItem("3542"));
      // dispatch(selectItem(false));
    }
  };

  // const handleEditClick = (itemId: string) => {
  //   setSelectedItem(itemId); // Set the selected item
  // };

  let selectedData: KanbanItem | undefined;
  let commentList: ReactElement[] = [];

  if (selectedItem !== null) {
    selectedData = items.find((item) => item.id === selectedItem);
    if (selectedData?.dueDate) {
      selectedData.dueDate = new Date(selectedData.dueDate);
    }

    if (selectedData?.commentIds) {
      commentList = [...selectedData.commentIds]
        .reverse()
        .map((commentId, index) => {
          const commentData = comments.find(
            (comment) => comment.id === commentId
          );
          const profile = profiles.find(
            (profile) => profile.id === commentData?.profileId
          );
          if (commentData && profile) {
            return (
              <ItemComment
                key={index}
                comment={commentData}
                profile={profile}
              />
            );
          }
          return null; // This returns null if data is not found
        })
        .filter((comment): comment is ReactElement => comment !== null);
    }
  }

  const [openModal, setOpenModal] = useState(false);

  const handleModalClose = (status: boolean) => {
    setOpenModal(false);
    if (status) {
      handleDrawerOpen();
      dispatch(
        openSnackbar({
          open: true,
          message: "Task Deleted successfully",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "alert",
          alert: { color: "success" },
          close: false,
        })
      );
    }
  };


  return (
    <Drawer
      sx={{
        ml: open ? 3 : 0,
        flexShrink: 0,
        zIndex: 1200,
        overflowX: "hidden",
        width: { xs: 320, md: 450 },
        "& .MuiDrawer-paper": {
          height: "100vh",
          width: { xs: 320, md: 450 },
          position: "fixed",
          border: "none",
          borderRadius: "0px",
        },
      }}
      variant="temporary"
      anchor="right"
      open={open}
      ModalProps={{ keepMounted: true }}
      onClose={handleDrawerOpen}
    >
      {open && (
        <>
          {selectedData ? (
            <>
              <Box sx={{ p: 3 }}>
                <Grid
                  container
                  alignItems="center"
                  spacing={0.5}
                  justifyContent="space-between"
                >
                  <Grid item sx={{ width: "calc(100% - 50px)" }}>
                    <Stack direction="row" spacing={0.5} alignItems="center">
                      <Button
                        variant="text"
                        color="error"
                        sx={{
                          p: 0.5,
                          minWidth: 32,
                          display: { xs: "block", md: "none" },
                        }}
                        onClick={handleDrawerOpen}
                      >
                        <HighlightOffIcon />
                      </Button>
                      <Typography
                        variant="h4"
                        sx={{
                          display: "inline-block",
                          width: "calc(100% - 34px)",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          verticalAlign: "middle",
                        }}
                      >
                        {selectedData.title}
                      </Typography>
                    </Stack>
                  </Grid>

                  <Grid item>
                    <Button
                      variant="text"
                      color="error"
                      sx={{ p: 0.5, minWidth: 32 }}
                      onClick={() => setOpenModal(true)}
                    >
                      <DeleteTwoToneIcon />
                    </Button>
                    <AlertItemDelete
                      title={selectedData.title}
                      open={openModal}
                      handleClose={handleModalClose}
                    />
                  </Grid>
                </Grid>
              </Box>
              <Divider />
              <PerfectScrollbar>
                <Box sx={{ p: 3 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <EditItem
                        item={selectedData}
                        profiles={profiles}
                        userStory={userStory}
                        columns={columns}
                        handleDrawerOpen={handleDrawerOpen}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h5" sx={{ mb: 2 }}>
                        Description
                      </Typography>
                      <Typography sx={{ mb: 2 }}>
                        {selectedData.description}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h5" sx={{ mb: 2 }}>
                        Comments
                      </Typography>
                      {commentList.length > 0 ? (
                        <Stack spacing={2}>{commentList}</Stack>
                      ) : (
                        <Typography sx={{ color: "text.secondary" }}>
                          No Comments found!
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </Box>
              </PerfectScrollbar>
            </>
          ) : (
            <Typography variant="h4" sx={{ p: 3 }}>
              Please select an item to view the details
            </Typography>
          )}
        </>
      )}
    </Drawer>
  );
};

export default ItemDetails;
